import { ActionPermission, can } from 'lib/specialPermissions';

const ACTIONS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

const TAGS = {
  PARENT: 'parent',
  DIRECTOR: 'director',
  STAFF_MEMBER: 'teacher',
  ADMIN: 'admin',
  CENTER: 'center',
  CLASSROOMS: 'classroom',
  STUDENTS: 'student',
};

interface PermissionsParams {
  user: any;
  calendarEvent: any;
  action: string;
  educatorsUser: any;
}


const permissions = ({ user, calendarEvent, action, educatorsUser }: PermissionsParams) => {
  const createdByUser = calendarEvent?.created_by.id === user.id;
  const canModifyEvents = educatorsUser
    ? can(educatorsUser, ActionPermission.ADD_EDIT_DELETE_EVENTS)
    : false;

  switch (action) {
  case ACTIONS.CREATE:
    return user.tags.some((tag: any) =>
      [TAGS.DIRECTOR, TAGS.ADMIN, TAGS.STAFF_MEMBER].includes(tag.name))
      || canModifyEvents;

  case ACTIONS.UPDATE: {
    const isAdmin = user.tags.some((tag: any) => [TAGS.ADMIN].includes(tag.name));

    return isAdmin
      ? true
      : (createdByUser || canModifyEvents);
  }

  case ACTIONS.DELETE: {
    const isAdmin = user.tags.some((tag: any) => [TAGS.ADMIN].includes(tag.name));

    return isAdmin
      ? true
      : (createdByUser || canModifyEvents);
  }

  default:
    return false;
  }
};

export default permissions;
